import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDraggableIconRectangles = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 9,
	height: 14,
	viewBox: "0 0 9 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2384_52316)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M3.33333 1H1V3.4H3.33333V1Z",
				fill: "#8EA1B8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.0013 1H5.66797V3.4H8.0013V1Z",
				fill: "#8EA1B8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.33333 5.80078H1V8.20078H3.33333V5.80078Z",
				fill: "#8EA1B8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.0013 5.80078H5.66797V8.20078H8.0013V5.80078Z",
				fill: "#8EA1B8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.33333 10.5996H1V12.9996H3.33333V10.5996Z",
				fill: "#8EA1B8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.0013 10.5996H5.66797V12.9996H8.0013V10.5996Z",
				fill: "#8EA1B8"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2384_52316",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 7,
			height: 12,
			fill: "white",
			transform: "translate(1 1)"
		})
	}) })]
});
export default SvgDraggableIconRectangles;
